import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {

    create: async ({ email, password, firstName, lastName, companyName, jobRole, howHeard, request_to_join, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "researchers/signup";

        const body = JSON.stringify({
            researcher: {
                email: email,
                password: password,
                first_name: firstName,
                last_name: lastName,
                company_name: companyName,
                job_role: jobRole,
                how_heard_about_us: howHeard,
                request_to_join: request_to_join,
            }
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                body: body,
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    checkEmail: async ({ email, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "researchers/check_email";

        const body = JSON.stringify({
            researcher: {
                email: email,
            }
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                body: body,
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },





}